import { FuelInteractiveIcon } from '@frete.com/fuel-react';
import ContactListButton from 'components/ui/Menu/ContactListButton';
import React from 'react';
import * as Styled from './styled';

export const TopActionButtons: React.FC<{
  onClose: () => void;
  showCloseButton: boolean;
  hasContactFeature: boolean;
  isSmallProfile: boolean;
  scrolledValue: number;
}> = ({ onClose, showCloseButton, hasContactFeature, isSmallProfile, scrolledValue }) => (
  <>
    {showCloseButton && (
      <Styled.CloseButtonWrapper>
        <FuelInteractiveIcon
          data-testid="close-button"
          icon="close"
          iconStyle="outlined"
          onClick={onClose}
          size="large"
        />
      </Styled.CloseButtonWrapper>
    )}
    {isSmallProfile && hasContactFeature && (
      <Styled.ContactListButtonWrapper scrolledValue={scrolledValue} data-testid="contact-list-button-wrapper">
        <ContactListButton />
      </Styled.ContactListButtonWrapper>
    )}
  </>
);
